var map = {
	"./_default.json": 422,
	"./ancot.json": 423,
	"./bmarken.json": 424,
	"./cittaviva.json": 425,
	"./coop.json": 426,
	"./crai.json": 427,
	"./csp.json": 428,
	"./doreca.json": 429,
	"./doro.json": 430,
	"./ekom.json": 431,
	"./enel.json": 432,
	"./fashionzclub.json": 433,
	"./goovi.json": 434,
	"./jsc.json": 435,
	"./lcng.json": 436,
	"./lie.json": 437,
	"./mauto.json": 438,
	"./mysarca.json": 439,
	"./retex-bistrot.json": 440,
	"./retex.json": 441,
	"./self-service.json": 442,
	"./smarttouch.json": 443,
	"./smkt.json": 444,
	"./voghera.json": 445,
	"./wikimuseo.json": 446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 766;